import React, { useEffect, useState } from 'react';
import {
  Box,
  Button,
  Flex,
  Heading,
  Text,
  styled
} from '@sparrowengg/twigs-react';
import { useSelector } from 'react-redux';
import { IRootState } from 'commons/types';
import Desktop from 'commons/icons/desktop';
import { handleRedirectLink } from 'commons/helper';
import { product, PRODUCTS_LIST } from 'commons/constants';
import FallBackComponent from 'commons/components/fall-back';
import { FaceFrownIcon } from '@sparrowengg/twigs-react-icons';

const Fallback = () => {
  const [redirectUser, setRedirectUser] = useState(false);
  const userRedirect = useSelector((state: IRootState) => state?.userRedirect);
  const handleLogin = () => {
    Object.values(PRODUCTS_LIST).forEach((product) => {
      if (window.location.href.includes(product.value)) {
        window.location.href = product.redirectLink as string;
        return;
      }
    });
    window.location.href = `${process.env.REACT_APP_DEVELOPER_DOCS_URL}`;
  };

  const handleAutoRedirect = () => {
    const URL = window.location.href;
    if (URL.includes('/developer-portal-redirect') && userRedirect) {
      setRedirectUser(true);
      handleRedirectLink();
    }
  };
  useEffect(() => {
    handleAutoRedirect();
  }, []);

  const StyledSpan = styled('span', {
    color: '$neutral800',
    fontWeight: 700
  });

  return (
    <>
      {!redirectUser ? (
        <Flex
          flexDirection="column"
          alignItems="center"
          css={{ marginTop: '236px' }}
        >
          <Flex flexDirection="column" alignItems="center">
            <Desktop />
            <Heading css={{ marginTop: '$8' }} size="h4" weight="bold">
              Welcome to SurveySparrow's Developer Portal
            </Heading>
            <Box css={{ marginTop: '$8', alignSelf: 'flex-start' }}>
              <Text size="md" css={{ color: '$neutral700' }}>
                <StyledSpan>Step 1 - </StyledSpan>Login with SurveySparrow
              </Text>
              <Text size="md" css={{ color: '$neutral700', marginTop: '$6' }}>
                <StyledSpan>Step 2 - </StyledSpan>
                {
                  'Navigate to (Settings > Apps and Integration > Developer Portal)'
                }
              </Text>
            </Box>
            <Button
              color="primary"
              onClick={handleLogin}
              css={{ marginTop: '$12' }}
              size="lg"
            >
              Login
            </Button>
          </Flex>
        </Flex>
      ) : (
        <Flex
          alignItems="center"
          justifyContent="center"
          css={{ height: 'calc(100vh - 64px)' }}
        >
          <FallBackComponent
            isBlackTheme={false}
            title="Hang Tight!"
            description="You're about to be redirected. Just log in to jump back into the awesome world of AppNest."
            icon={<FaceFrownIcon size={40} color="#FBAB24" />}
            gradientColor="#FBAB24"
          />
        </Flex>
      )}
    </>
  );
};

export default Fallback;
